import { render } from "./CartEl.vue?vue&type=template&id=ced4937c"
import script from "./CartEl.vue?vue&type=script&lang=js"
export * from "./CartEl.vue?vue&type=script&lang=js"

import "./CartEl.vue?vue&type=style&index=0&id=ced4937c&lang=scss&scope=true"

import exportComponent from "C:\\BEST develop\\EJF\\best_ejf15\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__